import { gql } from '@apollo/client';

const searchSubscriptionProducts = gql`
  query searchSubscriptionProductsQuery($input: QueryProductsInput) {
    products: searchSubscriptionProducts(input: $input) {
      id
      sku
      merchantId
      merchantProductId
      taxCode
      glCode
      status
      currentVersion
      description
      type
      prices {
        frequency
        amount
        currency {
          name
          symbol
        }
      }
      products {
        id
        sku
        merchantProductId
        taxCode
        glCode
        status
        currentVersion
        prices {
          frequency
          amount
          currency {
            name
            symbol
          }
        }
        grants {
          id
          description
        }
      }
      grants {
        id
        description
      }
    }
  }
`;

export default searchSubscriptionProducts;
